export default [
  {
    content: {
      title: '<span class="title__line">THE CONDO</span><br /><span class="title__line">T-SHIRTS</span>',
    },
  },
  {
    content: {
      image: '/static/images/look_book/diesel_wynwood_img1.jpg',
      eyelet: '100% Pure Cotton',
    },
  },
  {
    content: {
      subtitle: 'El terminado más alto. Sorprendentemente elegante. La clase más elegante. Excesivamente exclusivo. 143 camisetas únicas.',
      text: 'Una colección cápsula única exclusivamente compuesta de 143 camisetas cosidas con máquina de precisión inspiradas en la colmena artística y cultural de Miami, Wynwood. Hechas del más puro algodón y extremadamente fácil de doblar, cada pieza puede ser usada como la prenda definitiva para cualquier ocasión.',
    },
  },
  {
    content: {
      title: '<span class="title__line">COMPRE UNA</span><br/><span class="title__line">CAMISETA</span><br /><span class="title__line">Y OBTENGA</span><br /><span class="title__line">UN APARTAMENTO</span><br/ ><span class="title__line">GRATIS*</span>',
      smalltext: 'se aplican exclusiones*',
    },
  },
  {
    content: [
      {
        title: 'S.M.L.',
        text: 'Talla:<br />Pequeña, Mediana, Grande.<br /><br />Valor:<br />Corto, mediano, largo plazo.',
      },
      {
        title: 'Sé dinámico, sé valiente.',
        text: 'Conviértase en una parte integral de un grupo seleccionado de individuos que estén seguros de lo que quieren. Y eso es exactamente lo que todos notarán.',
      },
    ],
  },
  {
    content: {
      image: '/static/images/look_book/diesel_wynwood_img2.jpg',
      eyelet: '',
    },
  },
  {
    content: {
      title: 'Hecho para ser usado.',
      text: '¿Existe un mejor lugar para vestir esta prenda única que el área más inclusiva y creativa de América? No lo creemos. No se preocupe. Ya está listo. Esta colección es tan exclusiva que los clientes recibirán un apartamento en el vecindario más moderno y con más auge de Miami como regalo de promoción.',
    },
  },
  {
    content: {
      title: 'TEMPORADA DE PRE-VENTA EN DIESEL WYNWOOD',
    },
  },
  {
    content: [
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img3.jpg',
          title: 'T-SHIRT A1-L4<br />STUDIO<br />S SIZE',
          price: '$ 399.000',
          smalltext: 'se aplican exclusiones*',
        },
      },
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img4.jpg',
          title: 'T-SHIRT D6-L4<br />2 BDRM<br />M SIZE',
          price: '$ 949.000',
          smalltext: 'se aplican exclusiones*',
        },
      },
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img5.jpg',
          title: 'T-SHIRT E4-L4<br />2 BDRM + DEN<br />L SIZE',
          price: '$ 1.399.000',
          smalltext: 'se aplican exclusiones*',
        },
      },
    ],
  },
  {
    content: {
      image: '/static/images/look_book/diesel_wynwood_img6.jpg',
    },
  },
  {
    content: [
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img7.jpg',
          title: 'T-SHIRT F1-L6<br />3 BDRM<br />XL SIZE',
          price: '$ 1.599.000',
          smalltext: 'se aplican exclusiones*',
        },
      },
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img8.jpg',
          title: 'T-SHIRT F2-L8<br />PENTHOUSE<br />XXL SIZE',
          price: '$ 5.500.000',
          smalltext: 'se aplican exclusiones*',
        },
      },
    ],
  },
  {
    content: {
      title: 'LAS CAMISETAS MÁS CARAS DEL MUNDO',
    },
  },
  {
    content: {
      title: '<span class="title__line">POR TAL CALIDAD</span><br /><span class="title__line">IRRACIONAL,</span><br /><span class="title__line">EL PRECIO PARECE</span><br /><span class="title__line">ESTAR ACORDE</span><br /><span class="title__line">EN COMPARACIÓN</span><br /><span class="title__line">A OTROS.</span>',
    },
  },
  {
    content: {
      subtitle: 'No acepte compromisos.<br />Solo lo mejor es la respuesta.',
      text: 'Arte y negocios, una nueva versión de lo que significa el estilo de vida urbano. Un éxito que mezcla paisajes metropolitanos con connotaciones naturales. La esencia de Diesel: una colección de lujo total con confort y moda de vanguardia.',
    },
  },
  {
    content: {
      image: '/static/images/look_book/diesel_wynwood_img9.jpg',
    },
  },
  {
    content: {
      title: '<span class="title__line"><span class="title__letter">C</span><span class="title__letter">O</span><span class="title__letter">N</span><span class="title__letter">T</span><span class="title__letter">A</span><span class="title__letter">C</span><span class="title__letter">T</span></span>',
    },
  },
];
